export type MixpanelEventName =
  /** When a user lands on a blog page */
  | "Blog - Viewed"
  /** When a user clicks a DreamSearch card on the blog page */
  | "Blog - Clicked Carousel Dreamsearch Card"
  /** When a user clicks "See more" on the blog page */
  | "Blog - Clicked Carousel Dreamsearch See More"
  /** When a user clicks the form funnel banner that sits below the hero image on a blog page */
  | "Blog - Clicked Form Funnel Banner"
  /** When a user clicks "See more" on the blog page */
  | "Blog - Clicked Plain Text CTA"
  /** When a customer clicks "Talk to Skipper" on the blog page */
  | "Blog - Go to Career Dashboard Coach"
  /** @deprecated When a customer clicks "Talk to Skipper" on the blog page */
  | "Blog - Go to Coach"
  /** When a customer clicks "Let's try it" on the blog page */
  | "Blog - Go to Dream Search"
  /** When a customer clicks "Search * classes near 12345" button on a blog page */
  | "Blog - Search by Zip"
  /**  */
  | "Career Dashboard - Dream Search - Go to Coach"
  /**  */
  | "Career Dashboard - Blog - Go to Coach"
  /**  */
  | "Career Dashboard - Home Page - Go to Coach"
  /** When a customer answers poll of the day */
  | "Career Dashboard - Poll of the Day - Answered"
  /** When a customer clicks "Take the quiz" on the poll of the day page */
  | "Career Dashboard - Poll of the Day - Clicked Take The Quiz"
  /** When a customer clicks "Continue" after answering the poll of the day */
  | "Career Dashboard - Poll of the Day - Continue to QOTD"
  /** When a customer answers a question of the day */
  | "Career Dashboard - Question of the Day - Answered"
  /** When a customer clicks "Take the quiz" on the question of the day page */
  | "Career Dashboard - Question of the Day - Clicked Take The Quiz"
  /** When a customer clicks "View More" on the question of the day page */
  | "Career Dashboard - Question of the Day - View More"
  /** When a customer clicks "Back" on the question of the day page */
  | "Career Dashboard - Other QOTD Responses - Back"
  /** When a customer clicks "Continue" on the questionnaire landing page */
  | "Career Dashboard - Questionnaire - Clicked Continue"
  /** When a customer lands on the career goal step */
  | "Career Dashboard - Questionnaire - Career Goal Viewed"
  /** When a customer clicks "Continue" on the career goal step */
  | "Career Dashboard - Questionnaire - Career Goal - Submitted"
  /** When a customer clicks "Back" on the career goal step */
  | "Career Dashboard - Questionnaire - Career Goal - Clicked Back"
  /** When a customer lands on the career change concern step */
  | "Career Dashboard - Questionnaire - Career Change Concern Viewed"
  /** When a customer clicks "Continue" on the career change concern step */
  | "Career Dashboard - Questionnaire - Career Change Concern - Submitted"
  /** When a customer clicks "Back" on the career change concern step */
  | "Career Dashboard - Questionnaire - Career Change Concern - Clicked Back"
  /** When a customer lands on the career timeline step */
  | "Career Dashboard - Questionnaire - Career Timeline Viewed"
  /** When a customer clicks "Continue" on the career timeline step */
  | "Career Dashboard - Questionnaire - Career Timeline - Submitted"
  /** When a customer clicks "Back" on the career timeline step */
  | "Career Dashboard - Questionnaire - Career Timeline - Clicked Back"
  /** When a customer lands on the career aspects ranking step */
  | "Career Dashboard - Questionnaire - Career Aspects Ranking Viewed"
  /** When a customer clicks "Continue" on the career aspects ranking step */
  | "Career Dashboard - Questionnaire - Career Aspects Ranking - Submitted"
  /** When a customer clicks "Back" on the career aspects ranking step */
  | "Career Dashboard - Questionnaire - Career Aspects Ranking - Clicked Back"
  /** When a customer lands on the "dig deeper" step */
  | "Career Dashboard - Questionnaire - Dig Deeper Viewed"
  /** When a customer clicks "Continue" on the "dig deeper" step */
  | "Career Dashboard - Questionnaire - Dig Deeper - Submitted"
  /** When a customer clicks "Back" on the "dig deeper" step */
  | "Career Dashboard - Questionnaire - Dig Deeper - Clicked Back"
  /** When a customer lands on the job enjoyment step */
  | "Career Dashboard - Questionnaire - Job Enjoyment Viewed"
  /** When a customer clicks "Continue" on the job enjoyment step */
  | "Career Dashboard - Questionnaire - Job Enjoyment - Submitted"
  /** When a customer clicks "Back" on the job enjoyment step */
  | "Career Dashboard - Questionnaire - Job Enjoyment - Clicked Back"
  /** When a customer lands on the job dislike step */
  | "Career Dashboard - Questionnaire - Job Dislike Viewed"
  /** When a customer clicks "Continue" on the job dislike step */
  | "Career Dashboard - Questionnaire - Job Dislike - Submitted"
  /** When a customer clicks "Back" on the job dislike step */
  | "Career Dashboard - Questionnaire - Job Dislike - Clicked Back"
  /** When a customer lands on the career aspects desired step */
  | "Career Dashboard - Questionnaire - Career Aspects Desired Viewed"
  /** When a customer clicks "Continue" on the career aspects desired step */
  | "Career Dashboard - Questionnaire - Career Aspects Desired - Submitted"
  /** When a customer clicks "Back" on the career aspects desired step */
  | "Career Dashboard - Questionnaire - Career Aspects Desired - Clicked Back"
  /** When a customer lands on the Skipper Type page */
  | "Career Dashboard - Skipper Type Viewed"
  /** When a customer clicks "Expand" on the Skipper Type summary text */
  | "Career Dashboard - Skipper Type - Clicked Expand"
  /** When a customer clicks "Collapse" on the Skipper Type summary text */
  | "Career Dashboard - Skipper Type - Clicked Collapse"
  /** When a customer clicks a career match on the Skipper Type page */
  | "Career Dashboard - Skipper Type - Clicked Career Match"
  /** When a customer scrolls to the bottom of the Skipper Type page */
  | "Career Dashboard - Skipper Type - Scrolled to Career Matches"
  /** When a customer clicks the "Continue to dashboard" button on the Skipper Type page */
  | "Career Dashboard - Skipper Type - Clicked Continue to Dashboard"
  /** When a customer lands on a dynamic AI generated step */
  | "Coach - AI Questions - 1"
  /** When a customer lands on a dynamic AI generated step */
  | "Coach - AI Questions - 2"
  /** When a customer lands on a dynamic AI generated step */
  | "Coach - AI Questions - 3"
  /**
   * When a customer lands on a dynamic AI generated step
   * (Step 4 has been removed as of May 3, 2024)
   * */
  | "Coach - AI Questions - 4"
  /** When a customer lands on the career step */
  | "Coach - Career"
  /** When a customer clicks Let's start on the coach homepage */
  | "Coach - Clicked Start"
  /** When a customer lands on the coaching style selection step */
  | "Coach - Coaching Style"
  /** When a customer lands on the create account step */
  | "Coach - Contact"
  /** When a customer lands on the degree level selection step */
  | "Coach - Degree Level"
  /** When a customer lands on a the AI generated goals summary */
  | "Coach - Goals Summary"
  /** When a customer lands on the intent selection step */
  | "Coach - Intent"
  /** When a customer selects their intended flow */
  | "Coach - Intent - Selected Intent"
  /** Deprecated */
  | "Coach - Nickname"
  /** When a customer lands on the main focus step */
  | "Coach - Main Focus"
  /** When a customer lands on the phone verification step */
  | "Coach - Phone Verification - Code Sent"
  | "Coach - Phone Verification - Code Verified"
  /** When a customer lands on the program comparison step */
  | "Coach - Program Comparison"
  | "Coach - Program Comparison - Clicked Dreamsearch Card"
  | "Coach - Program Comparison - Clicked See More Classes"
  /** When a customer lands on the reason step */
  | "Coach - Reason"
  /** When a customer lands on the final Skipper report */
  | "Coach - Report"
  | "Coach - Report - Clicked Dreamsearch Card"
  | "Coach - Report - Clicked See More Classes"
  /** When a customer lands on the timeframe step */
  | "Coach - Timeframe"
  /** When a customer lands on the coach landing page */
  | "Coach - Viewed"
  /** When a customer lands on the vocation interest step */
  | "Coach - Vocation Interest"
  /** When a customer interacts with the CookieYes consent banner */
  | "Consent Banner - Updated Preferences"
  /** When a customer creates an account with all necessary fields (on the backend). */
  | "Customer - Created Account"
  /** When a customer answers the poll of the day */
  | "Dashboard - Home - Answered Poll of the Day"
  /** When a customer clicks "Browse classes" on the dashboard page */
  | "Dashboard - Home - Clicked Browse Classes"
  /** When a customer clicks "Call School" on the dashboard page */
  | "Dashboard - Home - Clicked Call School"
  /** When a customer clicks "Apply for Federal Financial Aid" on the dashboard page */
  | "Dashboard - Home - Clicked Federal Financial Aid"
  /** When a customer clicks "Go to the Dream Wall" on the dashboard page */
  | "Dashboard - Home - Clicked Go to Dream Wall"
  /** When a customer clicks "Join the community" on the dashboard page */
  | "Dashboard - Home - Clicked Join the Community"
  /** When a customer views the dashboard home page */
  | "Dashboard - Home - Viewed"
  /** When a customer chooses Continue or View program on a Dashboard program card. */
  | "Dashboard - Clicked Program"
  /** When the customer uses filters on Dream Search page. */
  | "Dream Search - Filter"
  /** When the customer clicks the "Start" CTA on the DreamSearch form-funnel banner. */
  | "Dream Search - Clicked Find My Match"
  /** @deprecatedWhen the customer clicks "Talk to Skipper" on DreamSearch */
  | "Dream Search - Go to Coach"
  /** When the customer lands on the Dream Search page. */
  | "Dream Search - Landing Page"
  /** When the customer clicks a DreamSearch card on the main DreamSearch page. */
  | "Dream Search - Clicked Dreamsearch Card"
  /** When the customer clicks the "Browse other classes" button on the DreamSearch page. */
  | "Dream Search - No Results - Clicked Browse Other Classes"
  /** When the customer clicks the "Clear Filters" button on the DreamSearch page. */
  | "Dream Search - No Results - Clicked Clear Filters"
  /** When the customer clicks the "Sign up for updates" button on the DreamSearch page. */
  | "Dream Search - No Results - Clicked Create Account"
  /** When the customer clicks the sponsored disclaimer by DreamSearch results. */
  | "Dream Search - Clicked Sponsored Disclaimer"
  /** When the customer hovers over the sponsored disclaimer by DreamSearch results. */
  | "Dream Search - Sponsored Disclaimer - Hovered"
  /** When the customer scrolls the sponsored disclaimer into view. */
  | "Dream Search - Sponsored Disclaimer - Scrolled Into View"
  /** When the customer choose a program level preference on DreamSearch */
  | "Dream Search - Modal - Program Level Preference Presented"
  | "Dream Search - Modal - Program Level Preference Selected"
  | "Dream Search - Inline - Program Level Preference Selected"
  /** When the customer searches a term using the vocation search autocomplete. */
  | "Dream Search - Vocation Search"
  /** When the customer selects a search option using the vocation search autocomplete. */
  | "Dream Search - Vocation Search - Clicked"
  /** When the customer interacts with the Eligibility Requirement view. */
  | "Eligibility Issue - Change Answer"
  | "Eligibility Issue - Confirm Ineligibility"
  | "Eligibility Issue - Prompt Shown"
  /** When the customer clicks a DreamSearch card on the favorites page. */
  | "Favorites - Clicked Dreamsearch Card"
  /** When the customer scrolls the footer site disclaimer into view. */
  | "Footer - Site Disclaimer - Scrolled Into View"
  /** When the customer lands on the home page. */
  | "Homepage - Viewed"
  /** When the customer clicks a Dream Search card on the home page. */
  | "Homepage - Clicked Dreamsearch Card"
  /** When the customer clicks "Talk to Skipper" on homepage */
  | "Homepage - Go to Career Dashboard Coach"
  /** @deprecated When the customer clicks "Talk to Skipper" on homepage */
  | "Homepage - Go to Coach"
  /**
   * When the customer clicks the "Find My Match" CTA on the homepage.
   * Properties: `zip` and `surface` (`"hero" | "sticky"`) — `surface`
   * distinguishes the in-hero CTA from the persistent sticky CTA.
   */
  | "Homepage - Clicked Find My Match"
  /** When the customer clicks a Dream Search industry pill on homepage */
  | "Homepage - Navigate to DreamSearch"
  /** When the customer toggles an FAQ accordion on homepage */
  | "Homepage - Toggle FAQ Accordion"
  /** When the customer clicks a program chip on an industry card on homepage */
  | "Homepage - Industry Card Program Chip Click"
  /** When the customer clicks the "FINISH SIGN-UP" floating action button. */
  | "In Progress - Opened"
  /** When the customer clicks a program to resume from the  */
  | "In Progress - Resumed Sign Up"
  | "Inbound Affiliate - Edit"
  /** Intake events */
  | "Intake - Recommended For You - Clicked Dreamsearch Card"
  /** When a customer opens the Jobs page */
  | "Jobs - Viewed"
  /** When a customer clicks on a job card on the Jobs page */
  | "Jobs - Clicked Job Card"
  /** When a customer opens the job modal after clicking on a card */
  | "Jobs - Job Modal - Viewed"
  /** When a customer closes the job modal after clicking on a card */
  | "Jobs - Job Modal - Closed"
  /** When a customer clicks the "Apply" button on the job modal */
  | "Jobs - Job Modal - Clicked Apply Now"
  /** When a customer clicks the "Share" button on the job modal */
  | "Jobs - Job Modal - Clicked Share"
  /** When a customer clicks the "Apply Now" button on the job details panel */
  | "Jobs - Job Details - Clicked Apply Now"
  /** When a customer clicks the "Share" button on the job details panel */
  | "Jobs - Job Details - Clicked Share"
  /** When a customer opens the job details page */
  | "Jobs - Job Details Page - Viewed"
  /** When a customer clicks the "Apply Now" button on the job details page */
  | "Jobs - Job Details Page - Clicked Apply Now"
  /** When a customer clicks the "Share" button on the job details page */
  | "Jobs - Job Details Page - Clicked Share"
  /** When a customer searches for a job title in the job search bar */
  | "Jobs - Search - Job Title Search"
  /** When a customer searches for a location in the job search bar */
  | "Jobs - Search - Location Search"
  /** When a customer toggles the remote only filter on the job search bar */
  | "Jobs - Search - Remote Only Toggled"
  /** When a customer uses the magic search bar */
  | "Magic Search - Performed"
  /** When a customer opens the Manage Account page */
  | "Manage Account - Viewed"
  /** When a customer opts out of email  on the Manage Account page */
  | "Manage Account - Clicked Email Notifications Opt-Out"
  /** When a customer opts out of SMS notifications on the Manage Account page */
  | "Manage Account - Clicked SMS Notifications Opt-Out"
  /** When a customer toggles email notifications on the Manage Account page */
  | "Manage Account - Clicked Email Notifications Toggle"
  /** When a customer clicks the Delete Account button on the Manage Account page */
  | "Manage Account - Clicked Delete Account"
  /** When a customer confirms account deletion on the Manage Account page */
  | "Manage Account - Confirmed Delete Account"
  /** When the customer clicks a DreamSearch card on the metro page. */
  | "Metro - Clicked Dreamsearch Card"
  | "Program - Browse More Classes"
  /** When the customer clicks a DreamSearch card on the program page. */
  | "Program - Clicked Carousel Dreamsearch Card"
  /** When the customer clicks "See more" on the program page. */
  | "Program - Clicked Carousel Dreamsearch See More"
  /** // (mobile only - form always visible on desktop) // When the customer clicks the "Get started" button that appears on the program page to open the full-page modal. */
  | "Program - Clicked Get Started"
  /** When the customer clicks the pre-lead redirect button to be taken to another site. */
  | "Program - Clicked Pre-Lead Redirect"
  /** Authoritative server-side signal: a program-flow lead was blocked at the
   *  eligibility step because the school's pre-ping endpoint reported the
   *  customer as a duplicate. Emitted once per block by the server gate. */
  | "Program - Pre-Ping Blocked"
  /** Client page-view: the duplicate-block screen was shown to the user. Distinct
   *  from the server "Blocked" event (which counts blocks); this can fire per
   *  view/re-mount. Follows the *_Presented convention of the other block steps. */
  | "Program - Pre-Ping Block Presented"
  /** Clicked the next-best recommended program shown on the duplicate-block screen. */
  | "Program - Pre-Ping Block - Clicked Recommended Program"
  /** Clicked the "Browse other classes" DreamSearch CTA on the duplicate-block screen. */
  | "Program - Pre-Ping Block - Browse More Classes"
  /** Server-side: a lead was blocked at submit because the program is paused or
   *  at cap. One per block, so it counts the demand suppression turns away. */
  | "Program - Suppression Blocked"
  /** Client page-view of the waitlist screen; can fire per view/re-mount. */
  | "Program - Suppression Block Presented"
  /** Clicked the next-best recommended program shown on the waitlist screen. */
  | "Program - Suppression Block - Clicked Recommended Program"
  /** Clicked the "Browse other classes" DreamSearch CTA on the waitlist screen. */
  | "Program - Suppression Block - Browse More Classes"
  /** Client page-view when a suppressed clickout is blocked before enrollment. */
  | "Program - Pre-Lead Suppression Block Presented"
  /** Clicked a recommended program from the pre-lead suppression screen. */
  | "Program - Pre-Lead Suppression Block - Clicked Recommended Program"
  /** Clicked the browse CTA from the pre-lead suppression screen. */
  | "Program - Pre-Lead Suppression Block - Browse More Classes"
  /** When the customer clicks the hybrid sign-up external URL on the program page. */
  | "Program - Clicked External URL"
  /** When the customer collapses a previously expanded program's description (from the event above). */
  | "Program - Collapsed About"
  /** When the customer completes the address step. */
  | "Program - Completed Address"
  /** When the customer completes the basic info step. */
  | "Program - Completed Basic Info"
  | "Program - Basic Info - Name Last"
  | "Program - Basic Info - Name First"
  | "Program - Basic Info - Email"
  | "Program - Basic Info - Phone"
  /** When the customer completes the education level step. */
  | "Program - Completed Education Level"
  /** When the customer completes the email step. */
  | "Program - Completed Email"
  /** When the customer completes the high school graduation year step. */
  | "Program - Completed High School Graduation Year"
  /** When the customer completes the military affiliation step. */
  | "Program - Completed Military Affiliation"
  /** When the customer completes the RN license step. */
  | "Program - Completed RN License"
  /** When the customer completes the US citizenship step. */
  | "Program - Completed US Citizenship"
  /** When the customer completes the date of birth step. */
  | "Program - Completed Date of Birth"
  /** When the customer deselects a cohort on the program page that they had previously selected above. */
  | "Program - Deselected Class"
  /** When the customer clicks "Browse More Classes" on the directory school confirmation step. */
  | "Program - Directory School Confirmation - Browse More Classes"
  /** When the customer clicks "See more" when the program's description is being truncated because it's long enough. */
  | "Program - Expanded About"
  /** When the customer favorites the program. */
  | "Program - Add to Favorites"
  /** When a staff member visits and is blocked from completing the program flow. */
  | "Program - Inaccessible By Staff Presented"
  /** When the customer clicks the CTA to go to a specific program page from the provider page. Additional properties: `providerId`, `programId` */
  | "Program - Navigating to"
  /** When the customer submits their phone number through the phone step. */
  | "Program - Completed Phone"
  /** When the customer click the "Send code" button on the phone verification step. */
  | "Program - Phone Verification - Code Sent"
  /** When the customer successfully enters verification code on the phone verification step. */
  | "Program - Phone Verification - Code Verified"
  /** When the customer selects a specific cohort from the program page before submitting their eligibility info. */
  | "Program - Selected Class"
  /** When a student is shown the state restriction rejected step in the program flow. */
  | "Program - State Restriction Rejected Presented"
  /** When a student is shown the rejected step in the program flow. */
  | "Program - Student Rejected Presented"
  /** When a student is shown the age restriction step in the program flow. */
  | "Program - Age Restriction Presented"
  /** When the customer submits their eligibility info from the program page intake form. */
  | "Program - Viewed"
  /** When a student is shown the zip code restriction step in the program flow. */
  | "Program - Zip Code Restriction Presented"
  | "Program - Confirmation - Clicked Career Coach Start"
  | "Program - Confirmation - Clicked Recommended Program"
  | "Program - Confirmation - Clicked Browse More Classes"
  /** When a customer clicks call school button on thank you page */
  | "Program - Thank You - Called School"
  /** When a customer clicks manage programs button on thank you page */
  | "Program - Thank You - Manage Programs"
  /** When a customer clicks browse more programs button on thank you page */
  | "Program - Thank You - Browse More Programs"
  /** When the thank you page shows the accepted state */
  | "Program - Thank You - Accepted State Viewed"
  /** When the thank you page shows the rejected state */
  | "Program - Thank You - Rejected State Viewed"
  /** When the thank you page shows the timeout state */
  | "Program - Thank You - Timeout State Viewed"
  /** When the thank you page shows the outside hours state */
  | "Program - Thank You - Outside Hours State Viewed"
  /** When the thank you page shows the loading state */
  | "Program - Thank You - Loading State Viewed"
  /** When the thank you page shows the polling state */
  | "Program - Thank You - Polling State Viewed"
  /** When the customer clicks the edit button next to the phone number on the program page disclaimer. */
  | "Program - Disclaimer - Change Phone Number"
  /** When the customer submits their lead */
  | "Program - Lead Submitted"
  /** When the customer clicks the share button on the program */
  | "Program - Share"
  /** When the customer cancels a web share on the program */
  | "Program - Share - Cancel"
  /** When a student starts Skipper onboarding after the program flow */
  | "Provider - Collapsed About"
  | "Provider - Expanded About"
  /** When the customer lands on the provider page. Addtional properties: `providerId`, `providerFullName` */
  | "Provider - Viewed"
  | "Review - Edit"
  /** When a class is added */
  | "School - Class - Add"
  /** When a class is deleted */
  | "School - Class - Delete"
  /** When a class's info is changed */
  | "School - Class - Edit"
  /** When a customer is added */
  | "School - Customer - Add"
  /** When a customer is deleted */
  | "School - Customer - Delete"
  /** When a customer's info is changed */
  | "School - Customer - Edit"
  /** When a program is added */
  | "School - Program - Add"
  | "School - Program - Archive"
  /** When a program is deleted */
  | "School - Program - Delete"
  /** When a program's info is changed */
  | "School - Program - Edit"
  /** When a user's information is edited */
  | "School - User - Edit"
  /** When a user lands on an SEO metro page */
  | "SEO Metro - Viewed"
  /** When a user begins login flow and chooses a method. Properties include `method` (text, email, google, call) and `alreadyExists` (user account exists or not) */
  | "Sign In - Choose Method"
  /** When a user creates an account through the login flow */
  | "Sign In - Create Account"
  | "Sign In - Create Account - Name Last"
  | "Sign In - Create Account - Name First"
  | "Sign In - Create Account - Email"
  | "Sign In - Create Account - Phone"
  /** When the customer click the "Send code" button on the phone verification step through the login flow. */
  | "Sign In - Phone Verification - Code Sent"
  /** When the customer successfully enters verification code on the phone verification step through the login flow. */
  | "Sign In - Phone Verification - Code Verified"
  /** When a user signs in successfully through the login flow */
  | "Sign In - Success"
  /** When a user signs in successfully. Properties include `method` (text, email, google, call) and `alreadyExists` (user account exists or not) */
  /** @deprecated Use `Sign In - *` instead */
  | "Sign In"
  /** When a new vocation is added */
  | "Staff - Vocation - Add"
  /** When a vocation's info is changed */
  | "Staff - Vocation - Edit"
  /** When a page is viewed */
  | "Page Viewed"
  /** When a visitor sees a form-flow or landing-page experiment. */
  | "Form Funnel - Experiment Viewed"
  /** When a customer views a form funnel page */
  | "Form Funnel - Viewed"
  /** Server-side: a form-funnel enrollment reached LEAD with a known page origin. */
  | "Form Funnel - Lead Created"
  /** Successful submission returns an enrollment ID to join with its funnel journey. */
  | "Form Funnel - Enrollment Linked"
  /** When a customer answers a question in a form funnel */
  | "Form Funnel - Question Answered"
  /** When a customer completes a step in a form funnel */
  | "Form Funnel - Step Completed"
  /** When a customer is disqualified from a form funnel */
  | "Form Funnel - Disqualified"
  /** When results are shown in a form funnel */
  | "Form Funnel - Results Shown"
  /** When a customer is redirected due to out of state location in form funnel */
  | "Form Funnel - Out of State Redirect"
  /** When a customer clicks a clickout in a form funnel */
  | "Form Funnel - Clickout Clicked"
  /** When a customer clicks search on a no match result in form funnel */
  | "Form Funnel - No Match - Search Clicked"
  /** When a customer is auto-redirected to DreamSearch after a no match result in form funnel */
  | "Form Funnel - No Match - Auto Redirected"
  /** When a customer clicks a similar program on a no match result in form funnel */
  | "Form Funnel - No Match - Similar Program Clicked"
  /** When a customer clicks search on a program unavailable result in form funnel */
  | "Form Funnel - Unavailable - Search Clicked"
  /** When a customer clicks a similar program on a program unavailable result in form funnel */
  | "Form Funnel - Unavailable - Similar Program Clicked"
  /** When a hosted flow step is completed in a form funnel */
  | "Form Funnel - Hosted Step Completed"
  /** When a lead is submitted in a form funnel */
  | "Form Funnel - Lead Submitted"
  /** When a visitor is first bucketed into a funnel A/B variant */
  | "Form Funnel - Variant Assigned"
  /**
   * Fired server-side when the pre-ping loop excludes a Provider before
   * showing it to the user. Properties: providerId, handler, reason
   * (DUPLICATE | timeout | missing-credential | blocked-url | unknown-handler
   * | missing-required-scope | error), customerId (if available), funnelId.
   */
  | "Form Funnel - Pre-Ping Excluded"
  /**
   * Fired server-side when getFormFunnelMatches returns needsContact: true —
   * the top DreamSearch candidate has a pre-ping config and the client needs
   * to collect first/last/email/phone (verified) before the pre-ping fires.
   * Properties: funnelId, topProviderId, handler, customerId (if available).
   * ENG-6248.
   */
  | "Form Funnel - Pre-Match Contact Required"
  /** When a CMS admin asks a question in the Codebase Chat */
  | "CMS - Codebase Chat - Question Asked"
  /** When a CMS admin starts a new Codebase Chat conversation */
  | "CMS - Codebase Chat - Conversation Started"
  /** When an admin or school user opens the Recent Activity accordion */
  | "Admin - Recent Activity - Opened";

/**
 * Events that bypass the admin role filter in useMixpanel.
 * These events are tracked regardless of the user's role.
 */
export const MIXPANEL_ADMIN_BYPASS_EVENTS: MixpanelEventName[] = [
  "Admin - Recent Activity - Opened",
];
